import { createRouter, createWebHistory } from 'vue-router'

/* Layout */
import adminRoutes from './modules/admin'
import customersRoutes from './modules/customers'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/',
    redirect: '/auth-redirect'
  },
  {
    path: '/login-c',
    component: () => import('@/views/auth/Login2C.vue'),
    hidden: true
  },
  {
    path: '/login-b',
    component: () => import('@/views/auth/Login2B.vue'),
    hidden: true
  },
  {
    path: '/account-transfer',
    component: () => import('@/views/auth/AccountTransfer.vue'),
    hidden: true
  },
  {
    path: '/pass-reset',
    component: () => import('@/views/auth/PassReset.vue'),
    hidden: true
  },
  {
    path: '/pass-update',
    component: () => import('@/views/auth/PassUpdate.vue'),
    hidden: true
  },
  {
    path: '/forget-password',
    component: () => import('@/views/auth/ForgetPassword.vue'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/auth/auth-redirect.vue'),
    hidden: true
  },
  {
    path: '/azure-redirect',
    component: () => import('@/views/auth/azure-redirect.vue'),
    hidden: true
  },
  {
    path: '/403',
    component: () => import('@/views/error-page/403.vue'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404.vue'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401.vue'),
    hidden: true
  },
  {
    path: '/environment',
    component: () => import('@/views/environment/index.vue'),
    hidden: true
  },
  // {
  //   path: '/lasso/test',
  //   component: () => import('@/views/lasso/test'),
  //   hidden: true
  // },
  {
    path: '/lasso/callback',
    component: () => import('@/views/lasso/callback.vue'),
    hidden: true
  },
  {
    path: '/temporarily',
    component: () => import('@/views/customers/temporarily/index.vue'),
    hidden: true,
    children: [
      // {
      //   path: '',
      //   // hidden: true,
      //   component: resolve => require(['@/views/customers/temporarily'], resolve),
      //   name: 'temporarily'
      // },
      // {
      //   path: 'detail',
      //   component: resolve => require(['@/views/customers/temporarily/detail'], resolve),
      //   name: 'temporarily-detail',
      //   hidden: true
      // }
    ]
  },
  {
    path: '/temporarily/detail',
    component: () => import('@/views/customers/temporarily/detail/index.vue'),
    hidden: true
  },
  {
    path: '/page-pdf',
    component: () => import('@/views/pdf/index.vue'),
    hidden: true
  }
]

if (process.env.VUE_APP_ENV !== 'production') {
  constantRoutes.push(
    {
      path: '/login-bb',
      component: () => import('@/views/auth/Login2BInput.vue'),
      hidden: true
    }
  )
}

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // auth route here
  ...customersRoutes,
  ...adminRoutes
  // 404 page must be placed at the end !!!
  // { path: '*', redirect: '/404', hidden: true }
]

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: constantRoutes
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter({
    history: createWebHistory(),
    routes: constantRoutes
  })
  router.matcher = newRouter.matcher // reset router
}

export const HOME_ADMIN = '/customs-clearance/export/export-d'
export const HOME_CUSTOMER = '/customs-clearance-supply/export/export-d'
export const WELCOME_CUSTOMER = '/customer-welcome/'
export const WELCOME_ADMIN = '/admin-welcome/'
export const HOME_CUSTOMER_INFO = '/customers-center'

export default router
